import { render, staticRenderFns } from "./InvoiceDetailInfoBox.vue?vue&type=template&id=4a9bc1b1&"
import script from "./InvoiceDetailInfoBox.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetailInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports